import React from "react";
import PropTypes from "prop-types";

import TwoColumnLayout from "layouts/TwoColumn";
import StorageGateway from "lib/storage-gateway";
import JobTrackIframeEmbed from "components/common/JobTrackIframeEmbed";
import { NAV } from "constants/notification";
import LayerAtom from "../../atoms/Layer";
import { toast } from "react-toastify";
import withRouter from "helpers/withRouter";

/**
 * AdjustmentTypesListPage
 *
 * Layout:
 *    - {@link SSTCFLayout}
 *
 * Sections:
 *    - {@link AdjustmentTypesFilterSection}
        {@link AdjustmentTypesListSection}
 *
 */

class NotificationListPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      authToken: null,
      userId: null,
      nre_company_id: null,
      company_id: null,
      broadcastFlag: false,
    };
    this.loadData = this.loadData.bind(this);
    this.eventListnerFunction = this.eventListnerFunction.bind(this);
    this.postMessageToChild = this.postMessageToChild.bind(this);
  }
  postMessageToChild(messageType) {
    const iFrame = document.getElementById("worksanaNre");
    iFrame.contentWindow.postMessage(messageType, "*");
  }
  loadData() {
    this.postMessageToChild("REFRESH_NOTIFICATION_TABLE");
  }
  eventListnerFunction(event) {
    const data =
      event.data && typeof event.data !== "object" && JSON.parse(event.data);
    const message = data?.message;

    if (message === "BROADCAST") {
      this.setState({ broadcastFlag: true });
    } else if (message === "FAILED_TOAST") {
      toast.error(data?.content?.toastMessage);
    } else if (message === "SUCCESS_TOAST") {
      toast.success(data?.content?.toastMessage);
    } else if (message === "BROADCAST_SUCCESS") {
      this.loadData();
      toast.success(data?.content?.toastMessage);
    } else if (message === "REMINDER_SENDS_SUCCESS") {
      this.loadData();
      toast.success(data?.content?.toastMessage);
    }
  }

  componentDidMount() {
    window.addEventListener("message", this.eventListnerFunction, false);
    const oAuthToken = StorageGateway.get("graniteToken");
    const userId = StorageGateway.get("userId");
    const nre_company_id = StorageGateway.get("nre_company_id");
    const company_id = StorageGateway.get("company_id");
    this.setState({
      authToken: oAuthToken,
      userId: userId,
      nre_company_id: nre_company_id,
      company_id: company_id,
    });
  }
  componentWillUnmount() {
    window.removeEventListener("message", this.eventListnerFunction);
  }

  render() {
    const JobTrackAuthToken = StorageGateway.get("JobTrackBearerToken");
    const orgId = StorageGateway.get("jobTrackOrgId");
    const jwtToken = StorageGateway.get("iframe_jwt_token");

    const { pathname } = this.props?.location || {};
    const isLearning = pathname?.includes("learning");
    const screenId = isLearning ? 260 : 239;
    const src = `${process.env.REACT_APP_JOBTRAKS_BASE_URL}screen/${screenId}/${isLearning ? "Broadcast%20Notification" : "Notification%20Board"
      }?access_token=${JobTrackAuthToken}&jwt_token=${jwtToken}&jwt_expiry=3600&orgId=${orgId}&embed=true`;

    return (
      <TwoColumnLayout hideFooter={true}>
        <div
          style={{
            height: "calc(100vh - 102px - 75px)",
            marginRight: "-15px",
          }}
        >
          <JobTrackIframeEmbed src={src} />
        </div>
      </TwoColumnLayout>
    );
  }

}

NotificationListPage.propTypes = {
  InfoDucks: PropTypes.object.isRequired,
  infoList: PropTypes.object.isRequired,
  AdjustmentTypesDucks: PropTypes.object.isRequired,
};

export default withRouter(NotificationListPage);
